import React, { useContext } from 'react';
import { EzoicAd } from '@ezoic/react-sdk';
import { AdContext } from './AdProvider';
import { getEzoicPlacementId } from './ezoicPlacements';

function AdSlot({ placementKey, className = '' }) {
  const { isPremium } = useContext(AdContext);
  const ezoicId = getEzoicPlacementId(placementKey);

  if (isPremium || !ezoicId) return null;

  return (
    <div className={className} data-testid={`ad-${placementKey}`}>
      <EzoicAd id={ezoicId} />
    </div>
  );
}

export default AdSlot;
